"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coerceToNumber = exports.coerceToInteger = exports.percentageStringToDecimal = exports.decimalToPercentage = void 0;
function decimalToPercentage(value) {
    if (value === undefined)
        return "";
    const percentage = parseFloat((value * 100).toFixed(10)); // accounting for 10 digits after the decimal point
    return `${percentage}`;
}
exports.decimalToPercentage = decimalToPercentage;
function percentageStringToDecimal(value) {
    return Number(value) / 100;
}
exports.percentageStringToDecimal = percentageStringToDecimal;
const coerceToInteger = (value) => Math.round(value);
exports.coerceToInteger = coerceToInteger;
const coerceToNumber = (value) => Number(value);
exports.coerceToNumber = coerceToNumber;
